export default function rowClassName(row) {
  const isGroupRow = typeof row.id === 'string' && row.id.includes('group');
  return isGroupRow ? 'work-order__products_group-header' : null;
}
